import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="px-4 md:px-8 lg:px-16 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">おかやま印刷株式会社</h3>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>〒700-0000 岡山市北区○○町1-2-3</p>
              <p>TEL: 086-012-3456</p>
              <p>FAX: 086-012-3457</p>
              <p>営業時間: 9:00 - 18:00（日曜日・祝日定休）</p>
            </div>
          </div>

          {/* Site Map */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold">サイトマップ</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-gray-300 text-sm hover:text-primary transition-colors">
                トップ
              </Link>
              <Link to="/services" className="text-gray-300 text-sm hover:text-primary transition-colors">
                サービス案内
              </Link>
              <Link to="/works" className="text-gray-300 text-sm hover:text-primary transition-colors">
                制作実績
              </Link>
              <Link to="/company" className="text-gray-300 text-sm hover:text-primary transition-colors">
                会社概要
              </Link>
              <Link to="/contact" className="text-gray-300 text-sm hover:text-primary transition-colors">
                お問い合わせ
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} おかやま印刷株式会社. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-primary transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>

      {/* Background Decoration */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none opacity-5">
        <div className="text-9xl font-bold text-white whitespace-nowrap">
          OKAYAMA PRINTING
        </div>
      </div>
    </footer>
  );
};

export default Footer;
